import { memo, useContext } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import User from './user';
import UserWalletCard from './user-wallet-card';
import { ClientStatusContext } from '../../../../../common/client-status';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  }
}));

const useUserOnlyStyles = makeStyles(() => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'right'
  }
}));

const DesktopHead = () => {
  const hasWalletAvailable = useContext(ClientStatusContext).checkIfUserHasPortalPrivilege('WALLET_CREDIT');
  const classes = useStyles();
  const userOnlyClasses = useUserOnlyStyles();

  return (
    <Box className={hasWalletAvailable ? classes.container : userOnlyClasses.container}>
      {hasWalletAvailable ? <UserWalletCard /> : <></>}
      <User />
    </Box>
  );
};

export default memo(DesktopHead);
